module.exports = __webpack_public_path__ + "8c5c497a47304f276f99ad05e0c5a395.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBold/OpenSans-ExtraBold.svg?v=1.1.0
// module id = 1016
// module chunks = 0